// extracted by mini-css-extract-plugin
export default {"payments":"Qc-z","header":"Rc-z","adjustMarginAndPaddingNewDesign":"Sc-z"};